module.exports = __webpack_public_path__ + "static/media/CENARIO_anima.d0d2cd17.gif";